import styled from 'styled-components/macro'
import { Container as cont, Button } from 'reactstrap'
import Closed from '../../assets/svg/hm-closed.svg'
import { media } from 'ui/rwd'
import Uplands from '../../assets/images/uplands-bg.png'
import Circles from '../../assets/images/circles-bg.png'

const Container = styled(cont)`
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;
`

const Icon = styled.img`
  width: 5rem;
`

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & a {
    cursor: pointer;
  }
`

// NEW

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  justify-content: space-between;
  background-image: url(${Circles});
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: contain;
  padding: 2rem;
  width: 100vw;
  margin-left: -15px;
  ${media.sm`
    background-image: url(${Uplands});
    padding: 1rem;
    width: calc(100vw - 17px);
  `}
`

const LogoWrapper = styled.div`
  margin-top: 0.5rem;
  ${media.sm`
    margin-top: 2rem;
  `}
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${media.sm`
    flex-direction: row;
    justify-content: space-around;
  `}
  ${media.md`
    width: 75%;
  `}
  ${media.lg`
    width: 60%;
  `}
`

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
`

const RightContentSection = styled(ContentSection)`
  align-items: center;
  & button {
    width: 100%;
  }
`

const LeftContentSection = styled(ContentSection)`
  flex-direction: column-reverse;
  align-items: center;
  margin-bottom: 3rem;
  ${media.sm`
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 0;
  `}
`

const ContentButton = styled(Button)`
  margin: 1em;
`

const ClosedHM = styled.img.attrs(() => ({
  src: Closed
}))`
  margin-top: 2rem;
  width: 150px;
  ${media.sm`
    margin-top: 5rem;
    width: 200px;
  `}
`

const Heading = styled.h1`
  font-size: 3em;
`

export {
  Container,
  Icon,
  ErrorContainer,
  Wrapper,
  LogoWrapper,
  ContentWrapper,
  ContentSection,
  RightContentSection,
  ContentButton,
  ClosedHM,
  LeftContentSection,
  Heading
}
